import React from 'react';
import { Edit } from 'lucide-react';

function TellStoryCTA({ onClick }) {
  return (
    <div className="sidebar-card tell-story-cta">
      <div className="tell-story-icon">📝</div>
      <h3 className="tell-story-title">Tell the Story</h3>
      <p className="tell-story-description">
        Photos capture moments, but words capture meaning. What happened here?
      </p>
      <button className="tell-story-button" onClick={onClick}>
        <Edit size={16} />
        Add Your Story
      </button>
    </div>
  );
}

export default TellStoryCTA;
